import { AutoUser } from './auto-user';
import { CoordinatorService } from './coordinator.service';
import { ProjectMember } from './project-member';
import { ScriptUser } from './script-user';

export class ScriptUserManager {
    #coords: CoordinatorService;

    private _current?: ScriptUser;

    constructor(coords: CoordinatorService) {
        this.#coords = coords;
    }

    get current() {
        if (!this._current) {
            const t = this.#coords.project$.current?.team;
            if (t) {
                for (const pm of t.memberLs) {
                    if (pm.isCurrentUser) {
                        this._current = pm.scriptClass;
                        break;
                    }
                }
            } else {
                this._current = new ScriptUser(this.#coords);
            }
        }
        return this._current!;
    }

    list() {
        const t = this.#coords.project$.current?.team;
        if (t) {
            return t.memberLs.map((pm) => pm.scriptClass);
        } else {
            return [new ScriptUser(this.#coords)];
        }
        // return this.#coords.autouser$.autouserLs.map((au) => new ScriptAutoUser(this.#coords, au));
    }

    get currentAutouserSnapshot() {
        const au = new AutoUser(this.#coords, {
            isCurrentSnapshot: true,
            name: this.#coords.text('Exporter'),
        }).scriptClass;
        return au;
    }

    othersAsAutouserList() {
        return this.list()
            .filter((su) => !su.isCurrent && !su.isLocalUser)
            .map((x) => x.autouser());
    }

    get(nm: string) {
        if (nm === '_localUser') return this.current;
        for (const su of this.list()) {
            if (su.id === nm) return su;
        }
        nm = this.#coords.utils$.normalizeString(nm);
        for (const su of this.list()) {
            if (this.#coords.utils$.normalizeString(su.name) === nm) return su;
        }
        return null;
    }

    log(prefix = 'User Manager') {
        console.log(prefix);
        console.log(this.list());
    }

    display(prefix = 'User Manager') {
        console.log(prefix, this);
    }
}
